import { memo } from 'react';
import { Handle, Position, NodeResizer } from '@xyflow/react';


const getShape = ({ data, selected, toolBar }) => {

    return (
        <>
            <div className='post-it' style={{
                width: "100%",
                height: toolBar ? 50 : "100%",                
                padding: 5              
            }}>
                {toolBar ? (null) : (<textarea data-gramm="false" spellCheck={false} style={{ border: "none", resize: "none", width: "100%", height: "100%", backgroundColor: "transparent" }}
                value={data?.text} onChange={(e) => {
                    if (data) {
                        data.text = e.target.value;
                    }
                }}></textarea>)}

            </div>
        </>
    );
}

export {
    getShape
}